module.exports = __webpack_public_path__ + "static/media/all_plateforme_img_ar.7c3b2584.png";